import React, { createContext, useContext, useState } from "react";

// Create the context
const OverlayContext = createContext({
  showOverlay: false,
  setShowOverlay: () => {},
});

// Create a provider component
export const OverlayProvider = ({ children }) => {
  const [showOverlay, setShowOverlay] = useState(false);

  const value = {
    showOverlay,
    setShowOverlay,
  };

  return (
    <OverlayContext.Provider value={value}>{children}</OverlayContext.Provider>
  );
};

// Custom hook to use the overlay context
export const useOverlay = () => {
  const context = useContext(OverlayContext);

  if (context === undefined) {
    throw new Error("useOverlay must be used within an OverlayProvider");
  }

  return context;
};

export default OverlayContext;
